import { render, staticRenderFns } from "./PopupDetailComponent.vue?vue&type=template&id=ed1db124&scoped=true&"
import script from "./PopupDetailComponent.vue?vue&type=script&lang=js&"
export * from "./PopupDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1db124",
  null
  
)

export default component.exports